module.exports = __webpack_public_path__ + "img/icon6.0808a585.svg";